export const CLUSTER_SOURCE_ID = 'mapstack-points-cluster'
export const CLUSTER_MAX_ZOOM = 20
export const CLUSTER_LAYER_ID = 'Mapstack Visualization Cluster'
export const CLUSTER_SPIDERFY_ZOOM_LEVEL = 17
